import {
	TableHead,
	TableRow,
	TableCell,
	TableContainer,
	Table,
	TableBody,
	Box,
	Grid,
	//InputAdornment,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';
//import ClearIcon from '@mui/icons-material/Clear';
//import { IconButton } from '@mui/material';
import { CustomTooltipProps } from 'components/tooltips/CustomTooltip/CustomTooltip';
import { DatePicker } from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';
import { price } from 'lib/numbers';
//import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { useEffect, useState } from 'react';

type Props = {
	loading?: boolean;
	editUrl?: string;
	parkingOccupancy: ParkingOccupancy;
	paper?: boolean;
	disabled?: boolean;
	refetch?: (date?: string) => void;
	customAction?: CustomTooltipProps;
	selectedDate?: string;
	setSelectedDate?: (date: string) => void;
};
export default function ParkingOccupancyTable(props: Props) {
	const { parkingOccupancy } = props;
	const [openCalendar, setOpenCalendar] = useState(false);

	const { t } = useTranslation();

	const currentPrices = parkingOccupancy?.currentPrices ?? [];
	const parkedVehiclesByType = parkingOccupancy?.parkedVehicles?.byType ?? [];

	const addMissingVehicles = (currentPrices: CurrentPrices[], parkedVehiclesByType: ByType[]) => {
		const parkedDescriptions = parkedVehiclesByType.map((vehicle) => vehicle._id);

		currentPrices.forEach((price) => {
			if (!parkedDescriptions.includes(price.description)) {
				const newVehicle = {
					_id: price.description,
					totalVehiclesInside: 0,
					priceStay: price.priceStay,
					qrVehiclesPaid: 0,
					totalPaid: 0,
				};

				const index = parkedVehiclesByType.findIndex((vehicle) => vehicle._id > price.description);
				if (index === -1) {
					parkedVehiclesByType.push(newVehicle);
				} else {
					parkedVehiclesByType.splice(index, 0, newVehicle);
				}
			}
		});
	};

	addMissingVehicles(currentPrices, parkedVehiclesByType);

	const handleDateChange = (newValue: Moment | null) => {
		if (newValue) {
			const formatted = newValue.format('YYYY-MM-DD');
			props.setSelectedDate && props.setSelectedDate(formatted);
			props.refetch && props.refetch(formatted);
		}
	};

	const verifyDate = () => {
		const today = moment().format('YYYY-MM-DD');
		const shouldShowPrice = !props.selectedDate || props.selectedDate === today;
		return shouldShowPrice;
	};
	const today = moment();

	useEffect(() => {
		handleDateChange(today);
	}, []);

	return (
		<Box sx={{ flexGrow: 1 }}>
			<Grid container spacing={2}>
				<Grid item xs={12} md={12}>
					<DatePicker
						value={props.selectedDate ? moment(props.selectedDate) : null}
						onChange={(newValue) => handleDateChange(newValue)}
						label={t('common:date')}
						format="DD/MM/YYYY"
						open={openCalendar}
						onOpen={() => setOpenCalendar(true)}
						onClose={() => setOpenCalendar(false)}
						maxDate={today}
					/>
					{/*<DatePicker
						value={props.selectedDate ? moment(props.selectedDate) : null}
						onChange={(newValue) => handleDateChange(newValue)}
						label={t('common:date')}
						format="DD/MM/YYYY"
						open={openCalendar}
						onOpen={() => setOpenCalendar(true)}
						onClose={() => setOpenCalendar(false)}
						maxDate={today}
						slotProps={{
							textField: {
								fullWidth: true,
								InputProps: {
									startAdornment: (
										<InputAdornment position="start">
											<IconButton onClick={() => setOpenCalendar(true)} size="small">
												<CalendarTodayIcon fontSize="small" />
											</IconButton>
										</InputAdornment>
									),
									endAdornment: (
										<>
											{props.selectedDate && (
												<InputAdornment position="end">
													<IconButton
														onClick={() => {
															props.setSelectedDate && props.setSelectedDate('');
															props.refetch && props.refetch();
														}}
														size="small"
													>
														<ClearIcon fontSize="small" />
													</IconButton>
												</InputAdornment>
											)}
										</>
									),
								},
							},
						}}
					/>*/}
				</Grid>
				<Grid item xs={12} md={4}>
					<TableContainer component={Paper} sx={{ mt: 2, mb: 1 }}>
						<Table aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell sx={{ backgroundColor: 'green', color: 'white' }} colSpan={2}>
										{`${t('common:occupancyParking').toUpperCase()}`}:
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<TableCell component="th" scope="row">
										{`${t('common:type').toUpperCase()}`}{' '}
									</TableCell>
									<TableCell align="center">{`${t('common:quantity').toUpperCase()}`}</TableCell>
								</TableRow>
								{/*(parkingOccupancy?.parkedVehicles?.byType ?? []).map((row) => (*/}
								{(parkedVehiclesByType ?? []).map((row) => (
									<TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
										<TableCell component="th" scope="row">
											{row._id}
										</TableCell>
										<TableCell align="center">{verifyDate() ? row.totalVehiclesInside : ''}</TableCell>
									</TableRow>
								))}
								<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<TableCell component="th" scope="row">
										{`${t('common:total').toUpperCase()}`}{' '}
									</TableCell>
									<TableCell align="center">
										{verifyDate() ? parkingOccupancy?.parkedVehicles?.total ?? 0 : ''}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				<Grid item xs={12} md={4}>
					<TableContainer component={Paper} sx={{ mt: 2, mb: 1 }}>
						<Table aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell sx={{ backgroundColor: 'green', color: 'white' }} colSpan={3}>
										{`${t('common:solds').toUpperCase()}`}:{' '}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>{`${t('common:type').toUpperCase()}`} </TableCell>
									<TableCell align="center">{`${t('common:quantity').toUpperCase()}`}</TableCell>
									<TableCell align="center">{`${t('common:collected').toUpperCase()}`}</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{/*(parkingOccupancy?.parkedVehicles?.byType ?? []).map((row) => (*/}
								{(parkedVehiclesByType ?? []).map((row) => (
									<TableRow key={row._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
										<TableCell component="th" scope="row">
											{row._id}
										</TableCell>
										<TableCell align="center" component="th" scope="row">
											{row.qrVehiclesPaid}
										</TableCell>
										<TableCell align="center" component="th" scope="row">
											{price(row.totalPaid ?? 0)}
										</TableCell>
									</TableRow>
								))}
								<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<TableCell component="th" scope="row" colSpan={2}>
										{`${t('common:total').toUpperCase()}`} {`${t('common:collected').toUpperCase()}`}
									</TableCell>
									<TableCell align="center" component="th" scope="row">
										{price(parkingOccupancy?.parkedVehicles?.totalPaid ?? 0)}
									</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
				<Grid item xs={12} md={4}>
					<TableContainer component={Paper} sx={{ mt: 2, mb: 1 }}>
						<Table aria-label="simple table">
							<TableHead>
								<TableRow>
									<TableCell sx={{ backgroundColor: 'green', color: 'white' }} colSpan={2}>
										{`${t('common:currentPrices').toUpperCase()}`}:{' '}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								<TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
									<TableCell component="th" scope="row">
										{`${t('common:type').toUpperCase()}`}
									</TableCell>
									<TableCell align="center" component="th" scope="row">
										{`${t('common:price').toUpperCase()}`}
									</TableCell>
								</TableRow>
								{(parkingOccupancy?.currentPrices ?? []).map((row) => (
									<TableRow key={row.code} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
										<TableCell component="th" scope="row">
											{row.description}
										</TableCell>
										<TableCell align="center" component="th" scope="row">
											{verifyDate() ? price(row.priceStay) : ''}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
		</Box>
	);
}
